import React from "react";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
function MapNavIcon({ icon, tooltipTitle, onClick }) {

    return (
        <div
            onClick={onClick}
        >
            <Tooltip title={tooltipTitle}>
                <IconButton>
                    {icon}
                </IconButton>
            </Tooltip>
        </div>
    );
}

export default React.memo(MapNavIcon);
